// import Main from '@/view/main'

export default {
  path: "statistics",
  meta: {
    title: "自营统计"
  },
  name: "statistics",
  component: () => import("@/components/parent-view"),
  children: [
    {
      path: "",
      meta: {
        title: "销售统计"
      },
      component: () => import("@/components/parent-view"),
      children: [
        {
          path: "sales",
          meta: {
            title: "销售统计",
            ignoreBreadCrumb: true
          },
          name: "self-statistics-sales",
          component: () => import("@/view/v5/statistics/sales/index.vue")
        },
        {
          path: "project/:code",
          meta: {
            title: "项目详情",
            hideInTabBar: true
          },
          name: "self-statistics-projcet",
          component: () => import("@/view/v5/statement/project.vue")
        },
        {
          path: `member/:memId/`,
          name: "member-details",
          meta: {
            title: "会员详情",
            hideInTabBar: true
          },
          component: () => import("@/view/member/member-query/details.vue")
        }
      ]
    },
    {
      path: "",
      meta: {
        title: "商品统计"
      },
      component: () => import("@/components/parent-view"),
      children: [
        {
          path: "product",
          meta: {
            title: "商品统计",
            ignoreBreadCrumb: true
          },
          name: "self-statistics-prod",
          component: () => import("@/view/v5/statistics/product")
        }
      ]
    },
    {
      path: "",
      meta: {
        title: "采购统计"
      },
      component: () => import("@/components/parent-view"),
      children: [
        {
          path: "project/:code",
          meta: {
            title: "项目详情",
            hideInTabBar: true
          },
          name: "self-statistics-purchaser-projcet",
          component: () => import("@/view/v5/statement/project.vue")
        },
        {
          path: "purchase",
          meta: {
            title: "采购统计",
            notCache: false,
            ignoreBreadCrumb: true
          },
          name: "self-statistics-purchase",
          component: () => import("@/view/v5/statistics/purchase")
        },
        {
          path: "purchase/:id",
          meta: {
            hideInTabBar: true,
            title: "采购单详情"
          },
          component: () => import("@/view/v5/purchase/pur/detail.vue")
        }
        // {
        //   path: 'support/:id',
        //   name: 'self-statistics-purchase-support-detail',
        //   meta: {
        //     hideInTabBar: true,
        //     title: '供应商详情'
        //   },
        //   component: () => import('@/view/v5/purchase/detail.vue')
        // }
      ]
    },
    {
      path: "finance",
      meta: {
        title: "财务统计"
      },
      component: () => import("@/components/parent-view"),
      children: [
        {
          path: "",
          meta: {
            title: "财务统计",
            notCache: false,
            ignoreBreadCrumb: true
          },
          name: "self-statistics-finance",
          component: () => import("@/view/v5/statistics/finance/index.vue")
        },
        {
          path: "project/:code",
          meta: {
            title: "项目详情",
            hideInTabBar: true
          },
          name: "self-statistics-projcet",
          component: () => import("@/view/v5/statement/project.vue")
        },
        {
          path: `member/:memId/`,
          name: "member-details",
          meta: {
            title: "会员详情",
            hideInTabBar: true
          },
          component: () => import("@/view/member/member-query/details.vue")
        },
        {
          path: "detail/:code",
          meta: {
            title: "订单详情",
            hideInTabBar: true,
            detail: true,
            notCache: true
          },
          name: "self-order-detail",
          component: () => import("@/view/v5/order/detail.vue")
        }
      ]
    },
    {
      path: "operation",
      meta: {
        title: "运营统计"
      },
      component: () => import("@/components/parent-view"),
      children: [
        {
          path: "",
          meta: {
            title: "运营统计",
            ignoreBreadCrumb: true
          },
          name: "self-operation-statistics",
          component: () =>
            import("@/view/v5/statistics/operation/operation.vue")
        },
        {
          path: "project/:code",
          meta: {
            title: "项目详情",
            hideInTabBar: true
          },
          name: "self-operation-projcet",
          component: () => import("@/view/v5/statement/project.vue")
        }
      ]
    }
  ]
};



// WEBPACK FOOTER //
// ./src/router/routes/v5/statistics.js